import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';

export const mfaInputMessage = (): string => { return MessageService.translate('tws.mfa.default-input-code').replace('${codeSize}', '6') };
